import React from 'react'

const Selfcare = () => {
  return (
    <section className="self-care">
        <div className="container-xl">
            <div className="row align-items-center">
                <div className="col-lg-6 col-md-12 col-sm-12">
                    <div className="heading-area-mob">
                        <h2>Dry, rough skin <span>affects your confidence</span> & your love for self-care.</h2>
                        <img loading="lazy" decoding="async" width="421" height="565" className="img-fluid" src="images/self-care.jpg" alt="Face image"/>
                    </div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12">
                    <div className="content-area">
                        <h2>Dry, rough skin <span>affects your confidence</span> & your love for self-care.</h2>
                        <p>Imagine coming home after a long day, looking at your dry, lackluster skin in the mirror. You reach for your usual lotion, but it never quite gives you the moisture you crave. </p>
                        <p>No matter what you try, your skin stays thirsty, a little rough, and lacking that soft, touchable glow.</p>
                        <p>It’s frustrating—and it starts to feel like no product will ever give you that silky, smooth feeling.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Selfcare